"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _attendeeNetworkHealthEmitter = require("./attendeeNetworkHealthEmitter");
Object.keys(_attendeeNetworkHealthEmitter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _attendeeNetworkHealthEmitter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _attendeeNetworkHealthEmitter[key];
    }
  });
});